import * as React from 'react';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemText, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

import HydrotestLogo from '../../assets/logo-hydrotest.png';
import { useTranslation } from 'react-i18next';

const SideMenuDrawer = () => {
    const { t: translate } = useTranslation();
    const navigate = useNavigate()
    const menuList = [translate('enterReportTitle'), translate('pendingReports'), translate('synchronizedReports')];
    const [state, setState] = React.useState({
        top: false, //for later use
        left: false,
        bottom: false, //for later use
        right: false, //for later use
    });

    const handleClickMenu = (menu) => {
        switch(menu){
            case translate('enterReportTitle'):
                navigate("/", { state: { prev: true } })
                break;
            case translate('pendingReports'):
                navigate("/savedForm", { state: { prev: true } })
                break;
            case translate('synchronizedReports'):
                navigate("/history", { state: { prev: true } })
                break;
        }
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List sx={{width: 300}}>
                <img alt='' src={HydrotestLogo} style={{height: "30px", margin: "20px"}}/>
                {menuList.map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton onClick={() => handleClickMenu(text)} sx={{'&:hover':{backgroundColor: "#fbd200"}}}>
                            <ListItemText primary={<Typography style={{fontWeight: 'bold', borderLeft: '6px solid #fbd200', paddingLeft: '8px'}}>{text}</Typography>}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Typography sx={{paddingLeft: '16px', marginTop: '20px', color: 'gray'}}>
                {process.env.REACT_APP_ENVIRONMENT} V{process.env.REACT_APP_RELEASE_VERSION}
            </Typography>
        </Box>
    );

  return (
    <div>
        {["left"].map((anchor) => (
            <React.Fragment key={anchor}>
                <IconButton
                    onClick={toggleDrawer(anchor, true)}
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                    <MenuIcon />
                </IconButton>
                <Drawer
                    PaperProps={{sx:{width: 270, overflowX: 'hidden'}}}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                >
                    {list(anchor)}
                </Drawer>
            </React.Fragment>
        ))}
    </div>
  );
}
export default SideMenuDrawer;